import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { Field, useField } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import { select } from '@swf/core/store';

import CTAButton from '../../../../../CTAButton/CTAButton';
import Checkbox from '../../../../../Checkbox/Checkbox';
import OtherCitizenship from '../../../RMFCitizenship/components/OtherCitizenship/OtherCitizenship';
import UniqueIdPrompt from '../../../RMFUniqueIdPrompt/RMFUniqueIdPrompt';
import CNP from '../CNP/CNP';
import Citizenship from '../Citizenship/Citizenship';
import SelectCitizenship from '../SelectCitizenship/SelectCitizenship';

import { TXTWCL_I_understand_that_I_must_verif_ELL } from './Fields.messages.json';
import { cnpWrapper, container, dropdownWrapper } from './Fields.scss';

enum CitizenshipStep {
  Citizenship,
  Other
}

const citizenshipCountries = [Country.Germany, Country.Romania, Country.Canada];
const DAYS = 3;

const Fields = () => {
  const {
    input: { value: citizenship }
  } = useField('citizenship', { subscription: { value: true } });
  const siteId = useSelector(select.cms.getSiteId);
  const country = useSelector(select.account.getCountry);
  const isCAON = siteId === Sites.CA_ON;
  const isDE = siteId === Sites.DE;
  const isRO = siteId === Sites.ROM;

  const [citizenshipStep, setCitizenshipStep] = useState<CitizenshipStep | undefined>(
    citizenship
      ? citizenshipCountries.includes(citizenship) && citizenship === country
        ? CitizenshipStep.Citizenship
        : CitizenshipStep.Other
      : undefined
  );
  const isCitizenshipSelected = citizenshipStep === CitizenshipStep.Citizenship;
  const isOtherSelected = citizenshipStep === CitizenshipStep.Other;
  const showCNP = isCitizenshipSelected && isRO;
  const showHiddenDocumentNUmber = !isCitizenshipSelected && isRO && country === Country.Romania;
  const [checked, setChecked] = useState(false);
  const disableButton = isDE && (!checked || citizenshipStep === undefined);

  const handleCitizenshipSet = (citizenship: CitizenshipStep) => {
    if (citizenshipStep === citizenship) {
      return setCitizenshipStep(undefined);
    }
    setCitizenshipStep(citizenship);
  };

  return (
    <>
      <div className={container}>
        <Citizenship
          active={isCitizenshipSelected}
          handleClick={() => handleCitizenshipSet(CitizenshipStep.Citizenship)}
        />
        {showCNP && (
          <div className={cnpWrapper}>
            <CNP />
          </div>
        )}
        {showHiddenDocumentNUmber && (
          <Field name="nationalDocumentNumber">
            {() => (
              <input type="hidden" name="nationalDocumentNumber" id="nationalDocumentNumber" />
            )}
          </Field>
        )}
        <OtherCitizenship
          active={isOtherSelected}
          handleClick={() => handleCitizenshipSet(CitizenshipStep.Other)}
        />
        {isOtherSelected && (
          <div className={dropdownWrapper}>
            <SelectCitizenship
              onRomanianCitizenship={() => handleCitizenshipSet(CitizenshipStep.Citizenship)}
            />
          </div>
        )}
        {isDE && (
          <div>
            <Checkbox
              name="consentCheck"
              checked={checked}
              onChange={() => setChecked(!checked)}
              label={
                <Translation {...TXTWCL_I_understand_that_I_must_verif_ELL} values={{ 0: DAYS }} />
              }
            />
          </div>
        )}
      </div>
      {(isCAON ||
        isDE ||
        [CitizenshipStep.Other, CitizenshipStep.Citizenship].includes(
          citizenshipStep as CitizenshipStep
        )) && <CTAButton disabled={disableButton} />}
      <UniqueIdPrompt />
    </>
  );
};

export default Fields;
